<app-header></app-header>

<div style="height: 100px"></div>
<div class="faq-top">
  <div class="banner-overlay">
    <div class="container"></div>
  </div>
</div>
<div class="container">
  <div class="row">
    <div class="col-12">
      <h2 class="faq-top-one-item">{{ "faq" | translate }}</h2>
    </div>
  </div>
  <div class="rel">
    <div class="faq-slide-one">
      <a class="row" routerLink="/faq-supplier">
        <div class="row">
          <div class="col-2">
            <span>{{ "supplier" | translate }}</span>
          </div>
          <div class="col-6"></div>
          <div class="rounded-div flr">
          <img class="img-icon" src="/assets/img/misc/fast-delivery.png" />
          </div>
        </div>
      </a>
    </div>
    <div class="faq-slide-two">
      <a class="row" routerLink="/faq-merchant">
        <div class="col-9"></div>
        <span class="col-2">{{ "merchant" | translate }}</span>
        <div class="rounded-div flr justify-content-center">
            <img class="img-icon" src="/assets/img/misc/online-shopping.png" />
        </div>
      </a>
    </div>
  </div>

  <div style="height: 80px"></div>

  <div class="faq-container">
    <div *ngFor="let item of newsList" class="q-and-a row">
      <div class="row question">
        <h3 [innerHTML]="item.question"></h3>
      </div>
      <div class="row para">
        <span [innerHTML]="item.answer"></span>
      </div>
    </div>
  </div>
</div>

<!--
<div class="terms-section mt-50">
    <div class="container">
        <div class="blog-details-written">
            <div class="written-content">
                <div class="section">
                    <h4 >{{"term" | translate}}</h4>
                    <p> {{"generalCondition" | translate}} </p>
                    <ul>
                        <li> <i class='fal fa-check'></i> {{"generalConditionDetail1" | translate}} </li>
                        <li>
                            <i class='fal fa-check'></i> {{"generalConditionDetail2" | translate}}
                            <ul style="margin-left: 20px;">
                                <li> <i class='fal fa-check'></i> {{"generalConditionSubDetail1" | translate}} </li>
                                <li> <i class='fal fa-check'></i> {{"generalConditionSubDetail2" | translate}} </li>
                                <li> <i class='fal fa-check'></i> {{"generalConditionSubDetail3" | translate}} </li>
                                <li> <i class='fal fa-check'></i> {{"generalConditionSubDetail4" | translate}} </li>
                                <li> <i class='fal fa-check'></i> {{"generalConditionSubDetail5" | translate}} </li>
                                <li> <i class='fal fa-check'></i> {{"generalConditionSubDetail6" | translate}} </li>
                            </ul>
                        </li>
                        <li> <i class='fal fa-check'></i> {{"generalConditionDetail3" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"generalConditionDetail4" | translate}} </li>
                    </ul>
                </div>

                <div class="section">
                    <h4 >{{"platformActivities" | translate}}</h4>
                    <ul>
                        <li> <i class='fal fa-check'></i> {{"platformActivitiesDetail1" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"platformActivitiesDetail2" | translate}} </li>
                    </ul>
                </div>


                <div class="section">
                    <h4 >{{"platformUsers" | translate}}</h4>
                    <ul>
                        <li> <i class='fal fa-check'></i> {{"platformUsersDetail1" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"platformUsersDetail2" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"platformUsersDetail3" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"platformUsersDetail4" | translate}} </li>
                    </ul>
                </div>

                <div class="section">
                    <h4 >{{"priceAndPayment" | translate}}</h4>
                    <ul>
                        <li> <i class='fal fa-check'></i> {{"priceAndPaymentDetail1" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"priceAndPaymentDetail2" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"priceAndPaymentDetail3" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"priceAndPaymentDetail4" | translate}} </li>
                    </ul>
                </div>

                <div class="section">
                    <h4 >{{"verification" | translate}}</h4>
                    <ul>
                        <li> <i class='fal fa-check'></i> {{"verificationDetail1" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"verificationDetail2" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"verificationDetail3" | translate}} </li>
                    </ul>
                </div>

                <div class="section">
                    <h4 >{{"otherCondition" | translate}}</h4>
                    <ul>
                        <li> <i class='fal fa-check'></i> {{"otherConditionDetail1" | translate}} </li>
                        <li> <i class='fal fa-check'></i> {{"otherConditionDetail2" | translate}} </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div> -->

<app-footer
  [layout]="classname"
  [logo]="ftlogo"
  [shape]="ftshape"
  [bgimage]="ftbgimage"
  [color]="ftcolor"
></app-footer>
